<template>
    <article id="profile-layout">
        <profile-page></profile-page>
    </article>
</template>

<script>

    import ProfilePage from '@/ProfilePage/ProfilePage.vue';

    export default {
        name: 'ProfileLayout',
        components: {
            'profile-page': ProfilePage
        }
    }
</script>


// WEBPACK FOOTER //
// ProfileLayout.vue?ef20014e